import { getIEVersion } from '../helpers/getIEVersion';
import { setTimeout } from 'timers';

export class FullBleedImage {
    imgTag: HTMLImageElement;

    constructor(imageEl: HTMLImageElement) {
        this.imgTag = imageEl as HTMLImageElement;
        if (getIEVersion() > 0) {
            this.replaceImg();
        }
    }

    replaceImg() {
        let imgReplacement = document.createElement('div');
        imgReplacement.style.backgroundImage = `url('${this.imgTag.src}')`;
        imgReplacement.setAttribute('data-full-bleed-image-ie', '');
        if (this.imgTag.alt.length > 0) {
            let altReplacement = document.createElement('p');
            altReplacement.className = 'visually-hidden';
            altReplacement.innerHTML = this.imgTag.alt;
            imgReplacement.appendChild(altReplacement);
        }
        this.imgTag.parentNode.replaceChild(imgReplacement, this.imgTag);
        setTimeout(() => {
            imgReplacement.className = this.imgTag.className;
        }, 300);
    }
}